import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'

/**
 * 진도 기반 운영 알림 기준 — docs/features/admin-textbook-progress-board/progress-alert-decisions.md
 * 변경은 다음 오전 9시(Asia/Seoul) 발송부터 적용된다.
 */
export interface ProgressAlertSettings {
  /** 교재 발주 선행 레슨 수(현재 권 마지막 레슨에서 거슬러 센 수, 기본 1) */
  printOrderLeadLessons: number
  /** 누적테스트 준비 선행 레슨 수(기준 레슨 포함 일반 진도 레슨, 기본 7) */
  cumulativeLeadLessons: number
  /** ISO 8601 with offset */
  updatedAt?: string | null
  /** Teams 발송 경로 설정 여부 */
  deliveryConfigured: boolean
}

export interface ProgressAlertSettingsUpdate {
  printOrderLeadLessons: number
  cumulativeLeadLessons: number
}

export const PRINT_ORDER_LEAD_RANGE = { min: 0, max: 100 } as const
export const CUMULATIVE_LEAD_RANGE = { min: 1, max: 100 } as const

const BASE = '/admin/progress-alerts'

export const progressAlertQueryKeys = {
  settings: ['admin', 'progress-alerts', 'settings'] as const,
}

export const progressAlertApi = {
  getSettings: async (): Promise<ProgressAlertSettings> => {
    const res = await apiClient.get<ApiResponse<ProgressAlertSettings>>(`${BASE}/settings`)
    const data = res.data.data
    if (!data) throw new Error('진도 알림 설정 응답이 비어 있습니다.')
    return data
  },

  updateSettings: async (body: ProgressAlertSettingsUpdate): Promise<ProgressAlertSettings> => {
    const res = await apiClient.put<ApiResponse<ProgressAlertSettings>>(`${BASE}/settings`, body)
    const data = res.data.data
    if (!data) throw new Error('진도 알림 설정 응답이 비어 있습니다.')
    return data
  },
}
